
import { Dialog, DialogType, DialogFooter, PrimaryButton } from '@fluentui/react';

interface Props {
    title: string;
    message: string;
    onDismiss: () => void;
}

export default function AlertDialog({ title, message, onDismiss }: Props) {
    return (
        <Dialog
            hidden={false}
            onDismiss={onDismiss}
            dialogContentProps={{
                type: DialogType.close,
                title,
                subText: message,
            }}
        >
            <DialogFooter>
                <PrimaryButton text="OK" onClick={onDismiss} />
            </DialogFooter>
        </Dialog>
    );
}
